import React from "react"
import styled from "styled-components"

type BannerVariants = "outlined" | "filled"
type BannerColours = "success" | "warning"

type Props = {
  children: React.ReactNode
  leftIcon?: React.ReactNode | string
  variant?: BannerVariants
  colour?: BannerColours
  fullWidth?: boolean
}
export const Banner = ({ children, leftIcon, variant, colour, fullWidth }: Props) => {
  return (
    <BannerContainer $variant={variant} $colour={colour} $fullWidth={fullWidth}>
      {leftIcon && <div className="banner__leftIcon">{leftIcon}</div>}
      <div className="banner__content">{children}</div>
    </BannerContainer>
  )
}

interface BannerContainerProps {
  $variant?: BannerVariants
  $colour?: BannerColours
  $fullWidth?: boolean
}

const getBackgroundColour = (colour: BannerColours) => {
  switch (colour) {
    case "warning":
      return "#ffffff" // unknown for now
    case "success":
      return "#EDF5F3"
  }
}

const getBorder = (colour: BannerColours, variant: BannerVariants) => {
  if (variant === "filled") {
    return {}
  }

  switch (colour) {
    case "success":
      return {
        border: `3px solid #FB7123`,
        borderLeft: `9px solid #FB7123`,
      }
    case "warning":
      return {
        border: `3px solid #FB7123`,
        borderLeft: `9px solid #FB7123`,
      }
  }
}

const BannerContainer = styled.div<BannerContainerProps>(
  ({ $colour = "warning", $variant = "outlined", $fullWidth }) => ({
    background: getBackgroundColour($colour),
    padding: "1.5rem 1.5rem 1.5rem 1rem",
    borderRadius: "1rem",
    ...getBorder($colour, $variant),
    display: "flex",
    gap: "12px",
    ...(!$fullWidth
      ? {
          maxWidth: 1200,
          width: "90%",
        }
      : {}),
    color: $colour === "success" ? "#126732" : "initial",
    ".banner__content": {
      "> *": {
        width: "100%",
        margin: $variant === "filled" ? "0" : "0 0 8px",
      },
    },
  })
)
